import { Request } from "../../request";
import { getURL } from "../../utils";

// sites
export const get_sites = (has_products = null) => {
    return Request.get(getURL(`/api/corporation-pa/content/sites/`), {
      has_products,
    });
  };